export default {
  getIsLoading: state => state.isLoading,
  getLocalizations: state => state.localizations,
  getPagination: state => state.pagination,
  getCurrentPage: state => state.filters.params.page,
  getPageLength: state => state.filters.params.take,
  getLocalization: state => state.localization,
  getLocalizationValues: state => state.localization.localizations,
  getPlayerLocalizationMap(state) {
    return state.playerLocalizations.reduce((acc, item) => {
      acc[item.name] = item.value
      return acc
    }, {})
  },
}
